<div class="sidebar included">
	<app-sidebar-header [title]="'Price Breakdown'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		
		<!-- Flights -->
		<ng-container *ngIf="flight_tickets.length">
			<div class="price-breakdown-list--title">{{ 'priceBreakdown.text.flights' | ibeadmin | async }}</div>
			
			<ng-container *ngIf="booked_trip.data.fare.tripType !== 'M'">
				<ng-container *ngFor="let flight of flight_tickets; let i = index">
					<div class="price-breakdown-count" *ngIf="flight.item.details">
						<app-svg [svg]='INDRA_printAirlineLogo(flight.item.details)' [alt]="'priceBreakdown.alt.airlineLogo' | ibeadmin | async" class="price-breakdown__airline"></app-svg>
						<div class="price-breakdown-label">
							<div class="price-breakdown-title">
								<span class="destination">
									{{ flight.item.departureLocation.city }} -
									{{ flight.item.arrivalLocation.city }}
									<p class="muted">
										<a class="link" (click)="INDRA_handleDetailsClick(flight)" href="javascript:;" role="button">
											{{ 'priceBreakdown.link.details' | ibeadmin | async }}
										</a>
									</p>
								</span>
								<span class="datetime">{{ INDRA_printFlightDate(flight.item.details) | titlecase }}</span>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-container>
			
			<ng-container *ngIf="booked_trip.data.fare.tripType === 'M' && flight_tickets.length">
				<div class="multicity-content">
					<div class="multicity-details--left">
						<ng-container *ngFor="let flight of flight_tickets; let i = index">
							<div class="price-breakdown-count" *ngIf="flight.item.details">
								<app-svg [svg]='INDRA_printAirlineLogo(flight.item.details)' 
									[alt]="'priceBreakdown.alt.airlineLogo' | ibeadmin | async"
									class="price-breakdown__airline">
								</app-svg>
								<div class="price-breakdown-label">
									<div class="price-breakdown-title">
										<div class="multicity-details">
											<span class="destination">
												{{ flight.item.departureLocation.city }} -
												{{ flight.item.arrivalLocation.city }}
											</span>
											<p class="muted">
												<a class="link" (click)="INDRA_handleDetailsClick(flight)" href="javascript:;" role="button">
													{{ 'priceBreakdown.link.details' | ibeadmin | async }}
												</a>
											</p>
										</div>
										<span class="datetime">{{ INDRA_printFlightDate(flight.item.details) | titlecase }}</span>
									</div>
								</div>
							</div>
						</ng-container>
					</div>
				</div>
			</ng-container>
			
			<div *ngIf="flight_tickets.length">

				<div class="price-breakdown-count price-breakdown-count--total payment-table">
					<div class="price-breakdown-label payment-table__line">
						<div class="price-breakdown-title ">
							{{ 'priceBreakdown.title.total' | ibeadmin | async }}
						</div>

						<div class="price-right bold">
							{{ INDRA_getPrice('flights') | indracurrency }} 
						</div>
					</div>
				</div>

				<div class="fare-conditions-link__wrapper">
					<a class="link" 
						(click)="INDRA_handleFareAndTaxes()"
						[attr.aria-label]="'priceBreakdown.text.passengerPriceChange' | ibeadmin | async" 
						href="javascript:;" 
						role="button">
						{{ 'priceBreakdown.link.fareAndTaxesInformation' | ibeadmin | async }}
					</a>
				</div>
			</div>
		</ng-container>
		<!-- End Flights -->

		<!-- Discounts -->
		<ng-container *ngIf="discounts.length">
			<div class="divider"></div>
			<div class="price-breakdown-list">
				<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.discounts' | ibeadmin | async }}</div>
				<ul class="body">

					<ng-container>
						<li class="extras-feature extras-feature__price-breakdown" *ngFor="let discount of discounts;">
							<div class="extras-feature__label">
								<span class="capitalize">{{ discount.id ? discount.id : INDRA_getLabelTranslation(discount.type, 'text')  | ibeadmin:'sync' }}</span>
							</div>
							<span class="price">
								- {{ discount.currency !== 'FFP' ? (discount.amount | indracurrency: currencyCode) : (discount.amount + 'M' | indracurrency) }} 
							</span>
						</li>
					</ng-container>
				</ul>
			</div>

			<div class="price-breakdown-count price-breakdown-count--total payment-table" *ngIf="discounts.length">
				<div class="price-breakdown-label payment-table__line">
					<div class="price-breakdown-title">
						{{ 'priceBreakdown.title.total' | ibeadmin | async }}
					</div>
					<div class="price-right bold">
						- {{ INDRA_getPrice('discounts') | indracurrency }}
					</div>
				</div>
			</div>
			<!-- End Discounts -->
		</ng-container>

		<!-- Extras -->
		<ng-container *ngIf="INDRA_showExtras()">
			<div class="divider"></div>
			
			<div class="price-breakdown-list">
				<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.extras' | ibeadmin | async }}</div>
				<ul class="body">
					<li *ngFor="let summary of ancillaries; let i = index"
						class="extras-feature extras-feature__price-breakdown ">
						<app-svg title="Icon" 
							class="ancillary-icon" 
							svg="icons.svg#{{ summary.icon }}" 
							[alt]="'priceBreakdown.alt.ancillaryIcon' | ibeadmin | async">
						</app-svg>
						<div class="extras-feature__wrapper">
							<div class="extras-feature__label">
								<span 
									[attr.aria-label]="('priceBreakdown.aria.open' | ibeadmin | async) + ' ' + (summary.translation | ibeadmin | async) + ' ' + ('priceBreakdown.aria.extraDialog' | ibeadmin | async)" 
									>	
									<ng-container *ngIf="!summary.isPack">
										{{summary.quantity}} x 
									</ng-container>

									{{summary.translation | ibeadmin | async}}
								</span>
								<span class="lighter">
									{{ summary.destination }}
								</span>
							</div>
							<span class="price">
								<!-- TODO implement this
								<div class="updated-price" *ngIf="INDRA_isUpdatedPrice(summary)">
									<span class="updated-price-tag">
										New price
									</span>
									<span class="updated-price-original">
										{{ TAP_formatCash(70) }}
									</span>
								</div>
								-->
								{{ INDRA_printExtraCost(summary) | indracurrency }}
							</span>

						</div>
					</li>

					<li *ngIf="boughtCarbonOffsetExtra" class="extras-feature extras-feature__price-breakdown ">
						<app-svg title="Icon" class="ancillary-icon" svg="icons.svg#plane_related--eco-friendly" attr.tooltip="{{ 'priceBreakdown.text.carbonOffset' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.carbonOffsetIcon' | ibeadmin | async"></app-svg>
						<div class="extras-feature__label">
							<span [attr.aria-label]="'priceBreakdown.aria.openCarbonOffsetDialog' | ibeadmin | async">{{ 'priceBreakdown.text.carbonOffset' | ibeadmin | async }}</span>
						</div>
						<span class="price">{{ boughtCarbonOffsetExtra.amount.toFixed(2) + carbonOffsetCurrency | indracurrency }}</span>
					</li>

					<li *ngIf="boughtDanishFundExtra" class="extras-feature extras-feature__price-breakdown ">
						<app-svg title="Icon" class="ancillary-icon" svg="icons.svg#money_related--health_insurance_check" attr.tooltip="{{ 'priceBreakdown.text.danishFund' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.danishFundIcon' | ibeadmin | async"></app-svg>
						<div class="extras-feature__label">
							<span [attr.aria-label]="'priceBreakdown.aria.openCarbonOffsetDialog' | ibeadmin | async">{{ 'priceBreakdown.text.danishFund' | ibeadmin | async }}</span>
						</div>
						<span class="price">{{ boughtDanishFundExtra.amount.toFixed(2) + danishFundCurrency | indracurrency }}</span>
					</li>
					
					<li *ngFor="let feature of extra_stopover; let i = index" class="extras-feature extras-feature__price-breakdown ">
						<app-svg title="Icon" class="ancillary-icon" svg="icons.svg#{{ feature.icon || 'general--plus'}}" attr.tooltip="{{feature.label}}" [alt]="feature.label + ' icon'">
						</app-svg>

						<div class="extras-feature__label">
							<span [attr.aria-label]="'priceBreakdown.aria.openStopoverDialog' | ibeadmin | async">
								{{feature.label}}</span>
							<span class="lighter">{{ 'priceBreakdown.text.stopoverIn' | ibeadmin | async }} {{ feature.stopoverCityName }}</span>
						</div>

						<span class="price">{{ feature.value + feature.currency | indracurrency }}</span>
					</li>
					
					<li *ngIf="boughtTravelInsuranceExtra" class="extras-feature extras-feature__price-breakdown ">
						<app-svg title="Icon" class="ancillary-icon" svg="icons.svg#money_related--health_insurance_check" attr.tooltip="{{ 'priceBreakdown.text.insurance' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.insuranceIcon' | ibeadmin | async"></app-svg>
						<div class="extras-feature__label">
							<span [attr.aria-label]="INDRA_getPlanDescription(boughtTravelInsuranceExtra.extraInfo.insuranceItems.plan.ibeAdminKey) | titlecase">{{ INDRA_getPlanDescription(boughtTravelInsuranceExtra.extraInfo.insuranceItems.plan.ibeAdminKey) }}</span>
						</div>
						<span class="price">{{ boughtTravelInsuranceExtra.amount.toFixed(2) + insuranceCurrency | indracurrency }}</span>
					</li>

					<li *ngIf="boughtCarRentalExtra" class="extras-feature extras-feature__price-breakdown ">
						<app-svg title="Icon" class="ancillary-icon" svg="icons.svg#services--rent_a_car" attr.tooltip="{{ 'priceBreakdown.text.rentACar' | ibeadmin | async }}" [alt]="'priceBreakdown.alt.rentACarIcon' | ibeadmin | async"></app-svg>
						<div class="extras-feature__label">
							<a class="link" href="javascript:;" role="button">
								{{ 'priceBreakdown.text.rentACarIn' | ibeadmin | async }} {{ carRentalCity }}
							</a>
						</div>
						<span class="price">{{ boughtCarRentalExtra.amount.toFixed(2) + carRentalCurrency | indracurrency }}</span>
					</li>
				</ul>
			</div>

			<div class="price-breakdown-count price-breakdown-count--total payment-table">
				<div class="price-breakdown-label payment-table__line">
					<div class="price-breakdown-title ">
						{{ 'priceBreakdown.title.total' | ibeadmin | async }}
					</div>
					<div class="price-right bold">
						{{ INDRA_getPrice('ancillaries') | indracurrency }}
					</div>
				</div>
			</div>
		</ng-container>
		<!-- End Extras -->

		<!-- Other charges -->
		<ng-container *ngIf="(adminFee != null && adminFee != 0) || (surchargeAmount != null && surchargeAmount != 0)">
			<div class="divider"></div>
			
			<div class="price-breakdown-list">
				<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.otherCharges' | ibeadmin | async }}</div>
				<ul class="body">
					<li class="extras-feature extras-feature__price-breakdown" *ngIf="adminFee != 0">
						<div class="extras-feature__label">
							<span>{{ 'priceBreakdown.text.adminFee' | ibeadmin | async }}</span>
						</div>
						<span class="price">{{ INDRA_getPrice('adminFee').toFixed(2) + currency | indracurrency }}</span>
					</li>
					<li class="extras-feature extras-feature__price-breakdown" *ngIf="surchargeAmount != 0">
						<div class="extras-feature__label">
							<span>{{ 'priceBreakdown.title.surcharge' | ibeadmin | async }}</span>
						</div>
						<span class="price">{{ INDRA_getPrice('ccFee').toFixed(2) + currency | indracurrency }}</span>
					</li>
				</ul> 
			</div>
				
			<div class="price-breakdown-count price-breakdown-count--total payment-table">
				<div class="price-breakdown-label payment-table__line">
					<div class="price-breakdown-title">
						{{ 'priceBreakdown.title.total' | ibeadmin | async }}
					</div>

					<div class="price-right bold">
						{{ INDRA_getPrice('otherCharges').toFixed(2) + currency | indracurrency }}
					</div>
				</div>
			</div> 
		</ng-container>
		<!-- End Other charges -->


		<!-- Pay to our partners -->
		<ng-container *ngIf="boughtHotelBookingExtras && boughtHotelBookingExtras.length">
			<div class="divider"></div>
			
			<div class="price-breakdown-list">
				<div class="price-breakdown-list--title">{{ 'priceBreakdown.title.payToOurPartners' | ibeadmin | async }}</div>
				<ul class="body">
					<li class="extras-feature extras-feature__price-breakdown" *ngFor="let data of boughtHotelBookingExtras">
						<div class="extras-feature__label">
							<span>{{ 'priceBreakdown.text.hotelIn' | ibeadmin | async }} {{ data.city }}</span>
							<span class="lighter">{{ 'priceBreakdown.text.bookingCom' | ibeadmin | async }}</span>
						</div>
						<span class="price">{{ data.value + data.currency | indracurrency }}</span>
					</li>
				</ul>
			</div>

			<div class="price-breakdown-count price-breakdown-count--total payment-table">
				<div class="price-breakdown-label payment-table__line">
					<div class="price-breakdown-title">
						{{ 'priceBreakdown.title.total' | ibeadmin | async }}
					</div>
					<div class="price-right bold">
						{{ INDRA_getPrice('extras') | indracurrency }}
					</div>
				</div>
			</div> 
		</ng-container> 
		<!-- End Pay to our partners -->

		<!-- Create an account -->
		<!-- <div *ngIf="!userInfo">
			<div class="divider"></div>
			<div class="price-breakdown-account">
				<div>
					<a class="link bold" 
						href="javascript:void();" 
						(click)="showLoginModal()"
						[attr.aria-label]="'priceBreakdown.aria.openDialogToLogin' | ibeadmin | async">
						{{ 'priceBreakdown.link.loginCreateAccount' | ibeadmin | async }}
					</a>
					{{ 'priceBreakdown.text.toGetDiscount' | ibeadmin | async }}
				</div>
				<div>
					{{ 'priceBreakdown.text.dontHaveTapAccount' | ibeadmin | async }}
					<a class="link bold" 
						href="javascript:void();" 
						(click)="INDRA_handleSignUp()"
						[attr.aria-label]="'priceBreakdown.text.ariaAccountDialog' | ibeadmin | async">
						{{ 'priceBreakdown.link.createAccountNow' | ibeadmin | async }}
					</a>
					{{ 'priceBreakdown.text.getDiscountsImmediately' | ibeadmin | async }}
				</div>
			</div>
		</div> -->
		<!-- End create an account -->
		
	</div>

	<div class="sidebar-flight-extras">
		<ul class="body">
			<li class="extras-feature">
				<div class="extras-feature__label">
					<h3><strong>{{ 'priceBreakdown.title.passengersTotal' | ibeadmin | async }}</strong></h3>
					<div class="extras-feature__label--note">
						{{ 'priceBreakdown.text.feesCarrierChargesIncluded' | ibeadmin | async }}
					</div>
				</div>			
				<p class="price-total">
					<!-- <ng-container *ngIf="payingWithMiles">
						<strong class="price-total--original">{{ INDRA_printOriginalPrice() | indracurrency }}</strong>
						<div>
							<strong class="price-total--miles">{{ INDRA_printMiles() | indracurrency }}</strong>
							<strong> + </strong>
							<strong>{{ INDRA_printFinalPrice() | indracurrency }}</strong>
						</div>
					</ng-container>
					<strong *ngIf="!payingWithMiles">{{ INDRA_getPrice('finalAmountWithDiscountsAndNoMilesGo') | indracurrency }} </strong> -->
					<strong>{{ INDRA_getPrice('total') | indracurrency }} </strong>
				</p>
				<!-- <p class="price-total" *ngIf="isAwardTicket">
					<strong> {{ INDRA_getPrice('finalAmountWithDiscountsAndNoMilesGo') | indracurrency }} </strong>
				</p>	 -->
			</li>
		</ul>
	</div>

	<div #sidebar__footer class="sidebar__footer ">
	</div>

</div>
